import { Routes } from '@angular/router';

export const BlankLayout_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('app/auth/auth.module').then(m => m.AuthModule),
  },
];
